import type { PropsWithChildren, ReactNode } from 'react';

interface RecordPanelProps extends PropsWithChildren {
  readonly eyebrow?: string;
  readonly title: string;
  readonly subtitle?: string;
  /** Status indicator, e.g. a StatusPill. */
  readonly status?: ReactNode;
  /** Record actions, rendered in the footer. */
  readonly actions?: ReactNode;
}

/** The detail view for a selected record: header (title/status), body, actions. Same shape everywhere. */
export function RecordPanel({ eyebrow, title, subtitle, status, actions, children }: RecordPanelProps) {
  return (
    <section className="forq-record-panel">
      <header className="forq-record-panel__head">
        <div className="forq-record-panel__heading">
          {eyebrow ? <span className="forq-eyebrow">{eyebrow}</span> : null}
          <h2>{title}</h2>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
        {status ? <div className="forq-record-panel__status">{status}</div> : null}
      </header>
      <div className="forq-record-panel__body">{children}</div>
      {actions ? <footer className="forq-record-panel__actions">{actions}</footer> : null}
    </section>
  );
}

interface RecordFieldProps {
  readonly label: string;
  readonly value: ReactNode;
}

/** A single label/value pair. Wrap several in a `<div className="forq-record-fields">`. */
export function RecordField({ label, value }: RecordFieldProps) {
  return (
    <div className="forq-record-field">
      <span className="forq-record-field__label">{label}</span>
      <span className="forq-record-field__value">{value}</span>
    </div>
  );
}
